'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _sizes = require('../../../constants/sizes');

var _alignments = require('../../../constants/alignments');

var _primaryButton = require('../../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _secondaryButton = require('../../../atoms/buttons/secondaryButton');

var _secondaryButton2 = _interopRequireDefault(_secondaryButton);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalFooter = function (_React$Component) {
    _inherits(ModalFooter, _React$Component);

    function ModalFooter() {
        _classCallCheck(this, ModalFooter);

        return _possibleConstructorReturn(this, (ModalFooter.__proto__ || Object.getPrototypeOf(ModalFooter)).apply(this, arguments));
    }

    _createClass(ModalFooter, [{
        key: 'getPrimaryButton',
        value: function getPrimaryButton() {
            var defaultText = this.props.intl.formatMessage({ id: 'Modal.ok' });
            return _react2.default.createElement(_primaryButton2.default, { text: this.props.text || defaultText, clickEvent: this.props.closeEvent });
        }
    }, {
        key: 'getActionButtons',
        value: function getActionButtons() {
            return this.props.actionButtons.map(function (actionButton, i) {
                var clickEvent = function clickEvent() {
                    actionButton.clickEvent && actionButton.clickEvent();
                };
                return actionButton.primary ? _react2.default.createElement(_primaryButton2.default, { key: 'modal_footer_btn_' + i, text: actionButton.text, disabled: actionButton.disabled, clickEvent: clickEvent, left: _sizes.Sizes.xs, right: _sizes.Sizes.xs }) : _react2.default.createElement(_secondaryButton2.default, { key: 'modal_footer_btn_' + i, text: actionButton.text, disabled: actionButton.disabled, clickEvent: clickEvent, left: _sizes.Sizes.xs, right: _sizes.Sizes.xs });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var hasActionButtons = this.props.actionButtons && this.props.actionButtons.length;

            return _react2.default.createElement(
                _container2.default,
                { top: hasActionButtons ? _sizes.Sizes.md : _sizes.Sizes.sm, bottom: hasActionButtons ? _sizes.Sizes.xl : _sizes.Sizes.sm, inline: true, horizontalAlignment: _alignments.Alignments.center },
                this.props.actionButtons && this.getActionButtons() || this.getPrimaryButton()
            );
        }
    }]);

    return ModalFooter;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(ModalFooter);